// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"9b86e2b3","977":"e92f5cd5"}[chunkId] + ".chunk.js";
};